/* ==========================================================================
   Homara Deco — comportamiento propio
   Todo vanilla, sin librerías. Un init por componente, todos tolerantes a que
   su elemento no exista (el mismo archivo se carga en varias páginas).
   ========================================================================== */
(function () {
  var SIN_MOVIMIENTO = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- entradas al hacer scroll ----------------------------------------- */
  function initSube(raiz) {
    var elementos = (raiz || document).querySelectorAll('.hd-sube:not(.hd-vista)');
    if (!elementos.length) return;

    // Con "menos movimiento" NO mostramos todo de golpe: el CSS ya le quitó el
    // desplazamiento y deja solo el fundido, así la aparición al bajar se
    // mantiene. Solo nos rendimos si no existe el observador.
    if (!('IntersectionObserver' in window)) {
      elementos.forEach(function (el) {
        el.classList.add('hd-vista');
      });
      return;
    }

    var obs = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('hd-vista');
          obs.unobserve(e.target);
        });
      },
      { rootMargin: '0px 0px -6% 0px', threshold: 0.1 }
    );

    elementos.forEach(function (el, i) {
      el.style.transitionDelay = Math.min(i, 4) * 80 + 'ms';
      obs.observe(el);
    });

    // Red de seguridad, pero quirúrgica.
    //
    // El contenido arranca invisible para poder aparecer. Si el observador no
    // llega a dispararse nunca (motor raro, alguna extensión), quedarían
    // secciones en blanco. Pero revelar todo a ciegas rompe el efecto en los
    // navegadores donde SÍ funciona: lo de más abajo aparecería sin haber
    // scrolleado.
    //
    // Por eso miramos primero si el observador dio señales de vida: si reveló
    // aunque sea un elemento, confiamos en él y no tocamos nada.
    window.setTimeout(function () {
      var algunoAparecio = document.querySelector('.hd-sube.hd-vista');
      if (algunoAparecio) return;

      elementos.forEach(function (el) {
        el.classList.add('hd-vista');
      });
    }, 3000);
  }

  /* --- pasos de "La prueba": se ilumina el que estás leyendo ------------- */
  function initPasos(raiz) {
    var pasos = (raiz || document).querySelectorAll('[data-hd-paso]');
    if (!pasos.length) return;

    // Sin observador los pasos quedarían atenuados para siempre: los
    // encendemos todos y listo, el texto se lee igual.
    if (!('IntersectionObserver' in window)) {
      pasos.forEach(function (p) {
        p.classList.add('hd-activo');
      });
      return;
    }

    var obs = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (e) {
          e.target.classList.toggle('hd-activo', e.isIntersecting);
        });
      },
      // Banda estrecha en el centro de la pantalla: solo se enciende lo que
      // está realmente a la vista del ojo, no lo que asoma por el borde.
      { rootMargin: '-42% 0px -42% 0px', threshold: 0 }
    );

    pasos.forEach(function (p) {
      obs.observe(p);
    });
  }

  /* --- galería del producto --------------------------------------------- */
  function initGaleria(raiz) {
    var galerias = (raiz || document).querySelectorAll('[data-hd-galeria]');

    galerias.forEach(function (galeria) {
      if (galeria.dataset.hdListo === '1') return;
      galeria.dataset.hdListo = '1';

      var grande = galeria.querySelector('.hd-oferta__foto');
      var minis = galeria.querySelectorAll('[data-hd-mini]');
      if (!grande || !minis.length) return;

      minis.forEach(function (mini) {
        mini.addEventListener('click', function () {
          // Sacamos el srcset o el navegador seguiría eligiendo la foto vieja.
          grande.removeAttribute('srcset');
          grande.removeAttribute('sizes');
          grande.src = mini.dataset.grande;
          minis.forEach(function (m) {
            m.classList.toggle('hd-activo', m === mini);
          });
        });
      });
    });
  }

  /* --- selector de combos + barra fija ----------------------------------- */
  function initOferta(raiz) {
    var secciones = (raiz || document).querySelectorAll('.hd-oferta');

    secciones.forEach(function (seccion) {
      if (seccion.dataset.hdListo === '1') return;
      seccion.dataset.hdListo = '1';

      var opciones = seccion.querySelectorAll('[data-hd-opcion]');
      var campo = seccion.querySelector('[data-hd-variante]');
      var agregar = seccion.querySelector('[data-hd-agregar]');
      if (!opciones.length || !campo) return;

      var barra = seccion.querySelector('[data-hd-barra]');
      var barraNombre = seccion.querySelector('[data-hd-barra-nombre]');
      var barraPrecio = seccion.querySelector('[data-hd-barra-precio]');
      var barraBtn = seccion.querySelector('[data-hd-barra-btn]');

      function pintarBarra(opcion) {
        if (barraNombre) barraNombre.textContent = opcion.dataset.nombre || '';
        if (barraPrecio) barraPrecio.textContent = opcion.dataset.precio || '';
      }

      function elegir(opcion) {
        if (!opcion || opcion.disabled) return;
        opciones.forEach(function (o) {
          o.setAttribute('aria-checked', o === opcion ? 'true' : 'false');
          o.tabIndex = o === opcion ? 0 : -1;
        });
        campo.value = opcion.dataset.id;
        if (agregar) agregar.disabled = false;
        pintarBarra(opcion);
      }

      // Arranque: la marcada por el tema, si no la primera con stock.
      var inicial =
        seccion.querySelector('[data-hd-opcion][aria-checked="true"]:not([disabled])') ||
        seccion.querySelector('[data-hd-opcion]:not([disabled])');

      if (inicial) {
        elegir(inicial);
      } else if (agregar) {
        agregar.disabled = true;
        agregar.textContent = 'Sin stock por ahora';
      }

      opciones.forEach(function (opcion) {
        opcion.addEventListener('click', function () {
          elegir(opcion);
        });

        opcion.addEventListener('keydown', function (e) {
          var teclas = ['ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft'];
          if (teclas.indexOf(e.key) === -1) return;
          e.preventDefault();

          var vivas = Array.prototype.filter.call(opciones, function (o) {
            return !o.disabled;
          });
          var i = vivas.indexOf(opcion);
          if (i === -1) return;

          var paso = e.key === 'ArrowDown' || e.key === 'ArrowRight' ? 1 : -1;
          var destino = vivas[(i + paso + vivas.length) % vivas.length];
          elegir(destino);
          destino.focus();
        });
      });

      // La barra fija aparece recién cuando el selector se fue hacia arriba.
      if (barra && 'IntersectionObserver' in window) {
        var lista = seccion.querySelector('.hd-oferta__opciones');

        if (barraBtn && agregar) {
          barraBtn.addEventListener('click', function () {
            agregar.click();
          });
        }

        if (lista) {
          new IntersectionObserver(
            function (entradas) {
              entradas.forEach(function (e) {
                var yaPaso = !e.isIntersecting && e.boundingClientRect.top < 0;
                barra.hidden = !yaPaso;
              });
            },
            { threshold: 0 }
          ).observe(lista);
        }
      }
    });
  }

  /* --- carrusel de reseñas ----------------------------------------------- */
  function initVoces(raiz) {
    var carros = (raiz || document).querySelectorAll('[data-hd-voces]');

    carros.forEach(function (carro) {
      if (carro.dataset.hdListo === '1') return;
      carro.dataset.hdListo = '1';

      var pista = carro.querySelector('[data-hd-voces-pista]');
      var voces = carro.querySelectorAll('[data-hd-voz]');
      var puntos = carro.querySelectorAll('[data-hd-voces-punto]');
      var prev = carro.querySelector('[data-hd-voces-prev]');
      var next = carro.querySelector('[data-hd-voces-next]');
      var controles = carro.querySelector('.hd-voces__controles');
      if (!pista || voces.length < 2) return;

      // Si las tarjetas entran todas en pantalla, no hay nada que deslizar:
      // ofrecer flechas y puntitos sería mentirle al usuario. Los escondemos
      // y centramos las tarjetas. Se recalcula al cambiar el tamaño.
      //
      // OJO: no sirve mirar `scrollWidth > clientWidth`. En pantallas anchas la
      // pista lleva un relleno lateral grande (para alinear la primera tarjeta
      // con el resto de la página) y ese relleno solo ya dispara el desborde,
      // aunque las tarjetas sobren de espacio. Hay que medir LAS TARJETAS.
      function ajustarControles() {
        if (!voces.length) return;

        var estilos = getComputedStyle(pista);
        var separacion = parseFloat(estilos.columnGap) || 0;

        var anchoTarjetas = 0;
        for (var i = 0; i < voces.length; i++) {
          anchoTarjetas += voces[i].getBoundingClientRect().width;
        }
        anchoTarjetas += separacion * (voces.length - 1);

        var margen = parseFloat(getComputedStyle(carro).getPropertyValue('--hd-margen')) || 24;
        var disponible = document.documentElement.clientWidth - margen * 2;

        var entraTodo = anchoTarjetas <= disponible;
        carro.classList.toggle('hd-voces--entra-todo', entraTodo);
        if (controles) controles.hidden = entraTodo;
      }

      ajustarControles();

      var reajuste;
      window.addEventListener('resize', function () {
        window.clearTimeout(reajuste);
        reajuste = window.setTimeout(ajustarControles, 150);
      });

      function irA(i) {
        var indice = Math.max(0, Math.min(i, voces.length - 1));
        var destino = voces[indice];
        if (!destino) return;

        pista.scrollTo({
          left: destino.offsetLeft - pista.offsetLeft,
          behavior: SIN_MOVIMIENTO ? 'auto' : 'smooth'
        });

        // Pintamos el punto ya mismo en vez de esperar al evento de scroll:
        // el desplazamiento suave puede tardar, y el indicador debe responder
        // al toque al instante.
        pintar(indice);
      }

      function actual() {
        // Buscamos la reseña más cercana al borde izquierdo de la pista.
        // Dividir por el ancho parece más simple, pero si la pista todavía
        // mide 0 (sección aún sin maquetar) devuelve NaN y se pierde el punto
        // activo. Comparar distancias funciona siempre, y además respeta el
        // padding y el gap entre diapositivas.
        var refe = pista.scrollLeft + pista.offsetLeft;
        var mejor = 0;
        var minima = Infinity;

        for (var i = 0; i < voces.length; i++) {
          var distancia = Math.abs(voces[i].offsetLeft - refe);
          if (distancia < minima) {
            minima = distancia;
            mejor = i;
          }
        }

        return mejor;
      }

      function pintar(i) {
        puntos.forEach(function (p, j) {
          p.classList.toggle('hd-activo', j === i);
        });
      }

      function marcar() {
        pintar(actual());
      }

      if (prev) {
        prev.addEventListener('click', function () {
          irA(actual() - 1);
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          irA(actual() + 1);
        });
      }

      puntos.forEach(function (punto) {
        punto.addEventListener('click', function () {
          irA(parseInt(punto.dataset.indice, 10) || 0);
        });
      });

      var pendiente;
      pista.addEventListener(
        'scroll',
        function () {
          window.cancelAnimationFrame(pendiente);
          pendiente = window.requestAnimationFrame(marcar);
        },
        { passive: true }
      );

      marcar();
    });
  }

  /* --- arranque ---------------------------------------------------------- */
  function initTodo(raiz) {
    initSube(raiz);
    initPasos(raiz);
    initGaleria(raiz);
    initOferta(raiz);
    initVoces(raiz);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initTodo();
    });
  } else {
    initTodo();
  }

  // El editor de Shopify vuelve a dibujar secciones sueltas.
  document.addEventListener('shopify:section:load', function (e) {
    initTodo(e.target);
  });
})();
